import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { setAddOns } from './addon-actions';
import { setCTOConfiguration } from './cto-actions';

const ConfigurationWrapper = (Component) => (props) => {
    return (
        <Component {...props} />
    );
}
const EMPTY_OBJECT = {};

function mapStateToProps(state, ownProps) {
    let { addOns, ctoConfigurations } = state.productData;
    const { product } = ownProps;
    /**
     * If product prop provided, automatically map to that product
     */
    if(product && product.sku){
        ctoConfigurations = ctoConfigurations[product.sku] || EMPTY_OBJECT;
        addOns = addOns[product.sku] || EMPTY_OBJECT;
    }
    return {
        addOns,
        ctoConfigurations
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setAddOns: (sku, addOns) => dispatch(setAddOns(sku, addOns)),
        setCTOConfiguration: (sku,config) => dispatch(setCTOConfiguration(sku,config))
    }
};

const withConfigurations = compose(connect(mapStateToProps, mapDispatchToProps), ConfigurationWrapper);

export default withConfigurations;
